import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mensagemSso } from '@via-tax/contracts'
import { Aviso, Botao, Campo, Entrada } from '@via-tax/ui'
import { useState, type FormEvent } from 'react'
import logoVia from '../assets/via-logo.jpg'
import { mensagemDeErro, useTRPC } from '../trpc'

export function Login() {
  const trpc = useTRPC()
  const qc = useQueryClient()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  // Recusa do login único chega como ?sso_erro=<código> (apps/api/src/sso/rotas.ts).
  const [erroSso] = useState(() => mensagemSso(new URLSearchParams(window.location.search).get('sso_erro')))
  const [contingencia, setContingencia] = useState(false)
  const entrar = useMutation(
    trpc.sessao.login.mutationOptions({ onSuccess: () => qc.invalidateQueries({ queryKey: trpc.sessao.contexto.queryKey() }) }),
  )

  const enviar = (e: FormEvent) => {
    e.preventDefault()
    entrar.mutate({ email, senha })
  }

  return (
    <TelaEntrada titulo="Entrar">
      <div className="flex flex-col gap-3 text-sm leading-relaxed">
        {erroSso && <Aviso>{erroSso}</Aviso>}
        <p>
          <strong>Equipe da Via:</strong> entre pelo Via Processos, menu <em>Ferramentas → Via Tax</em>.
        </p>
        <p>
          <strong>Cliente:</strong> entre pelo Portal do Cliente, menu <em>Reforma Tributária</em> (usuário master).
        </p>
        {!contingencia && (
          <button type="button" onClick={() => setContingencia(true)} className="self-start text-xs text-tinta-3 underline">
            Acesso de contingência (e-mail e senha)
          </button>
        )}
      </div>
      {contingencia && (
      <form onSubmit={enviar} className="mt-4 flex flex-col gap-4 border-t border-linha pt-4">
        <Campo rotulo="E-mail">
          <Entrada type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required />
        </Campo>
        <Campo rotulo="Senha">
          <Entrada type="password" autoComplete="current-password" value={senha} onChange={(e) => setSenha(e.target.value)} required />
        </Campo>
        {entrar.isError && <Aviso>{mensagemDeErro(entrar.error)}</Aviso>}
        <Botao type="submit" variante="primario" disabled={entrar.isPending} className="mt-1">
          {entrar.isPending ? 'Entrando…' : 'Entrar'}
        </Botao>
      </form>
      )}
    </TelaEntrada>
  )
}

/** Moldura das telas de entrada (login e segundo fator). */
export function TelaEntrada({ titulo, largura = 'max-w-sm', children }: { titulo: string; largura?: string; children: React.ReactNode }) {
  return (
    <div className="grid min-h-full place-items-center bg-fundo p-6">
      <div className={`w-full ${largura}`}>
        <div className="mb-6 flex items-center gap-3">
          <img src={logoVia} alt="Via Contabilidade" className="h-14 w-auto rounded bg-white p-1" />
          <div className="border-l-2 border-acao pl-3 leading-tight">
            <p className="text-[15px] font-semibold tracking-tight text-navy">Via Tax</p>
            <p className="text-[11px] text-tinta-3">Simulação da Reforma Tributária · LC 214/2025</p>
          </div>
        </div>
        <div className="rounded-lg border border-linha bg-painel p-6 shadow-sm">
          <h1 className="mb-5 text-lg font-semibold">{titulo}</h1>
          {children}
        </div>
      </div>
    </div>
  )
}
